export default __webpack_public_path__ + "static/media/tractor.cc27f91b.jpg";